export { SkyproAvailableLanguages, SkyproAvailableLanguagesType, skyproAvailableLanguages } from './src/const';
export { SkyproDateToStringService } from './src/service/date-to-string';
export { SkyproCurrentLanguageService } from './src/service/current-language.service';
export { SkyproPriceToStringService } from './src/service/price-to-string';
export { SkyproSharedLocalizationModule } from './src/module';
export { DatePipe } from './src/pipes/date.pipe';
